module.exports = __webpack_public_path__ + "static/media/icons_grey_text.76e79e2c.svg";